export const NAV_ITEMS = ["colores", "aplicaciones", "características", "dónde comprar"]

export const GLOBAL_SITE_TAG = {
  [process.env.REACT_APP_LATAM_INSTANCE_ID]: "GTM-MJF8LZR"
}
